<template>
    <v-container>
        <!--v-layout align-center justify-center-->
        <v-layout align-center justify-center>
            <v-loading class="loading" v-model="loading" v-if="loading">
    
                <v-progress-circular persistent
                :size="70"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular>
        
            </v-loading>
            <v-flex xs12 sm8 md4>
                <!--v-card class="elevation-12"-->
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Editar Post</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!--v-form ref="form" v-model="valid" lazy-validation-->
                        <v-form ref="form" v-model="valid" lazy-validation>
           
                            
                            <v-text-field browser-autocomplete="new-texto" name="texto" label="Digite o texto" type="text"
                                          v-model="texto" data-cy="joinEmailField" required>
                            </v-text-field>
                            <!-- <br /> -->
                            <!-- <label class="v-label theme--light">Imagem:</label>
                            <img v-bind:src="urlImg" id="myimg" width="100%" />
                            <input type="file" @change="onFileSelected" id="fileButton" />
                            <progress value="0" max="100" id="uploader">0</progress>
                            <br /><br /> -->
                            
                            <v-text-field name="textoLink" label="Texto do link" type="text"
                                          v-model="textoLink" required>
                            </v-text-field>
                            <v-text-field name="link" label="Link" type="text"
                                          v-model="link" required>
                            </v-text-field>
                            
                            
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn-->
                        <v-btn color="primary" :disabled="!valid || !statusUpload" @click="editarPost" data-cy="joinSubmitBtn">Atualizar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import db from './firebaseInit';
import firebase,{ storage } from 'firebase';

import {mask} from 'vue-the-mask'

import { userProperties, cache } from '@/global.js'

export default {
    name: 'Editar-Post',
    directives: {mask},
    data() {
        return {
            valid: false,
            texto: null,
            textoLink: null,
            link: null,
            timestamp: null,
            dialog: false,
            loading: false,
            slug: null,
            extensao : null,
            statusUpload: true,
            tituloModal: "Post atualizado com sucesso!",
            urlImg: null
        };
    },
    methods: { // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
        editarPost(){
           this.loading = true 
            db.collection('posts_' + userProperties.escolaID).where("slug", "==", this.$route.query.slug)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach(doc => {
                    console.log(doc.id, " => ", doc.data());
                    // Build doc ref from doc.id
                    db.collection('posts_' + userProperties.escolaID).doc(doc.id).update({                        
                        slug: this.slug,
                        texto: this.texto,
                        textoLink: this.textoLink,
                        link: this.link,
                        extensao: this.extensao
                    }).then(docRef => {
                        console.log('Document written with ID: ', docRef.id);
                        cache.home = false;
                        //this.$router.push(`/${slug}/success`)
                        this.loading = false
                        this.dialog = true
                        
                    })
                    .catch( error => {
                        this.loading = false
                        console.log('Error adding document: ', error);
                        console.log("Erro na atualização dos dados. Tente novamente mais tarde!")
                    })
                    this.loading = false,
                    this.dialog = true

                });
            })
            
        },
        closeModal(){
            this.$router.push(`/`);
        },        
        submit() {
            if (this.$refs.form.validate() && this.statusUpload == true) {
            }
            if (this.$refs.form.validate() && this.statusUpload == false) {
                alert("Por favor, faça o upload da foto do perfil do usuário")
            } 
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        onFileSelected(event){
            this.loading = true;
            console.log(event);
            var file = event.target.files[0]
            var filename = event.target.files[0].name
            
            // Recupera imagem do storage
            var storageRef = firebase.storage().ref('postagens/'+this.slug+"."+filename.toString().split(".")[1])
            this.extensao = filename.toString().split(".")[1];
            var task = storageRef.put(file)
            var that = this;
            task.on('state_changed',
                function progress(snapshot){
                    var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    uploader.value = percentage;
                    that.loading = false;
                },
                function error(err){
                    alert("Error on upload. Check if image size is less than 900KB");
                    that.statusUpload = false;
                    that.loading = false;
                },
                function complete(){
                    that.extensao = filename.toString().split(".")[1];
                    that.statusUpload = true;
                    alert("Upload successful!");
                    that.loading = false;
                }
            )
        }
        
    },
    mounted() {
        //const slug = this.generateUUID()
        //this.slug = slug;

        // se perfil não for escola ou administrador
        if(userProperties.perfil == 1 || userProperties.perfil == 5 || userProperties.perfil == 6 || userProperties.perfil == 7){
            alert("Acesso negado!");
            this.$router.push(`/?redirect=`+window.location.pathname)
        }

        db.collection('posts_' + userProperties.escolaID).where("slug", "==", this.$route.query.slug)
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
                // doc.data() is never undefined for query doc snapshots
                console.log(doc.id, " => ", doc.data());               
                let customObj = doc.data()
                this.nome = customObj.nome;
                this.texto = customObj.texto;
                this.textoLink = customObj.textoLink;
                this.link = customObj.link;
                this.extensao = customObj.extensao;
                this.slug = customObj.slug;
            });

            var storageRef = firebase.storage().ref();
            var tangRef = storageRef.child('postagens/'+this.slug+'.'+this.extensao);

            // First we sign in the user anonymously
            //firebase.auth().signInAnonymously().then((result) => {
            // Once the sign in completed, we get the download URL of the image
            
            tangRef.getDownloadURL().then(urlImgFB =>                             {
                // Once we have the download URL, we set it to our img element
                console.log(urlImgFB);
                this.urlImg = urlImgFB;

                }).catch(function(error) {
                    // If anything goes wrong while getting the download URL, log the error
                    console.error(error);
                });

            this.loading = false;

        });

        
    }
};
</script>

<style scoped>
    .loading{
        position: absolute;
        top:20%;
        left:48%;
        z-index: 2;
    }

    .btCirculo{
        height: 30px;
        width: 30px;
    }

    .btCirculo a{
        color:#fff;
    }

    progress{
        width:100%;
        margin-top: 6px;
    }

    label.v-label.theme--light{
        margin-bottom: 6px;
        display: block
    }

    .adicionarItem.btCirculo{
        position: relative;
        top: 12px;
        left: 5px;
    }

    .excluirItem.btCirculo{
        position: relative;
        left: 5px;
        top:-10px;
    }

    .box-items-selecionados{
        background: silver;
        width: 100%;
        padding: 20px 5px 5px 10px;
    }

    .container{
        padding: 0 0 !important;
    }
    
</style>
